import React from "react";
import { connect } from "react-redux";
import PhysicalDetail from "../../../../Profile/Home/ProfileInformation/Physical/PhysicalDetail";
import getMemberPhysicalProfile from "../../../../../_selectors/profileSelectors/getMemberPhysicalProfile";

const Physical = ({ userProfile, showToast }) => {
  return <PhysicalDetail userProfile={userProfile} showEdit={false} />;
};

const mapStateToProps = (state, ownProps) => ({
  userProfile: getMemberPhysicalProfile(state)
});

export default connect(mapStateToProps)(Physical);



// WEBPACK FOOTER //
// ./src/_components/ViewProfile/Profile/ProfileInformation/Physical/index.js